import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { PRODUCT_LINE_VARIABLE_FRAGMENT } from 'graphql/fragments/product-line-variable';
import { Query as RootQuery } from 'graphql/models/generated';

export const PRODUCT_POSITION_VARIABLE_QUERY = gql`
  query productLineVariable(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!,
    $variableId: ID!
  ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        line(id: $lineId) {
          ...ProductLineVariableFragment
        }
      }
    }
  }
  ${PRODUCT_LINE_VARIABLE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class ProductPositionVariableQuery extends Query<RootQuery> {
  document = PRODUCT_POSITION_VARIABLE_QUERY;
}
